module.exports = __webpack_public_path__ + "img/growcify-no-fee-banner.0b143b6d.png";